import React from 'react';
import LandingPageView from "../views/landingPageView";

const LandingPagePresenter = () => {
    return (
        <LandingPageView/>
    );
};

export default LandingPagePresenter;
